import {
    VisitRequestTableRowFragment,
    VisitTableRowFragment,
} from '@/components/bulkQueue/tables/queries.gql.types';
import { MUIDataTableCustomHeadRenderer, MUISortOptions } from 'mui-datatables';

export type BulkTableRow = VisitRequestTableRowFragment | VisitTableRowFragment;

type ServiceRef = { id: string; name: string };
type AppointmentWithServices = {
    id: string;
    services: ServiceRef[];
    clinician: { id: string; fullName: string } | null;
};
type DisciplineRef = { id: string };

export type ServicesVisitRequestRow = VisitRequestTableRowFragment & {
    availableServices: ServiceRef[];
    appointments: AppointmentWithServices[];
    disciplines: DisciplineRef[];
};

export type ServicesVisitRow = VisitTableRowFragment & {
    visitRequests: {
        id: string;
        availableServices: ServiceRef[];
        appointments: AppointmentWithServices[];
    }[];
};

export type ServicesTableRow = ServicesVisitRequestRow | ServicesVisitRow;

export const adaptVisitToServicesVisitRequestRow = (
    visit: ServicesVisitRow,
    visitRequest: ServicesVisitRow['visitRequests'][number],
): ServicesVisitRequestRow =>
    ({
        ...visit,
        __typename: 'VisitRequest' as const,
        availableServices: visitRequest.availableServices,
        appointments: visitRequest.appointments,
    } as unknown as ServicesVisitRequestRow);

export type CellProps<
    T extends Record<string, unknown> = Record<string, unknown>,
    U extends BulkTableRow = BulkTableRow,
> = T & {
    entity: U;
};

export type VisitRequestCellProps<
    T extends Record<string, unknown> = Record<string, unknown>,
    U extends VisitRequestTableRowFragment = VisitRequestTableRowFragment,
> = T & {
    entity: U;
};

export type VisitCellProps<
    T extends Record<string, unknown> = Record<string, unknown>,
    U extends VisitTableRowFragment = VisitTableRowFragment,
> = T & {
    entity: U;
};

export type HeaderProps = {
    columnMeta: MUIDataTableCustomHeadRenderer;
    handleToggleColumn: (columnIndex: number) => void;
    sortOrder: MUISortOptions;
};
